<template>
    <BaseChip :size="size" :class="featureClasses[feature]"><slot /></BaseChip>
</template>

<script lang="ts">
import type { BaseChipSize } from "~vue/components/BaseChip.vue";

export type FeatureChipFeature = "three-sixty" | "journeys" | "self-reflect" | "team-reflect";

interface FeatureChipProps {
    feature: FeatureChipFeature;
    size?: BaseChipSize;
}
</script>

<script setup lang="ts">
import BaseChip from "~vue/components/BaseChip.vue";

const { feature, size = "2xs" } = defineProps<FeatureChipProps>();

const featureClasses: Record<FeatureChipFeature, string> = {
    "three-sixty": "feature-three-sixty",
    journeys: "feature-journeys",
    "self-reflect": "feature-self-reflect",
    "team-reflect": "feature-team-reflect",
};
</script>

<style scoped>
@layer components {
    .feature-three-sixty {
        --base-chip-bg: var(--color-chip-three-sixty-bg);
        --base-chip-text: var(--color-chip-three-sixty-text);
    }

    .feature-journeys {
        --base-chip-bg: var(--color-chip-journeys-bg);
        --base-chip-text: var(--color-chip-journeys-text);
    }

    .feature-self-reflect {
        --base-chip-bg: var(--color-chip-self-reflect-bg);
        --base-chip-text: var(--color-chip-self-reflect-text);
    }

    .feature-team-reflect {
        --base-chip-bg: var(--color-chip-team-reflect-bg);
        --base-chip-text: var(--color-chip-team-reflect-text);
    }
}
</style>
